import React, { useMemo } from 'react';
import { useGetFomoSmsVolumeQuery } from 'store/services/admin/analyticsApi';
import { AnalyticsPeriod } from 'types/interfaces/admin/analytics';
import StackedBarChart, { StackedBarChartRow } from 'components/admin/charts/StackedBarChart';

interface Props {
  period: AnalyticsPeriod;
  onPeriodChange: (period: AnalyticsPeriod) => void;
}

// Amber reads as "friction/warning" without being an alarming red, and is distinct from the
// purple SMS Alerts chart and the engagement-green/elite charts.
const FOMO_COLOR = '#F59E0B';

const FomoSmsChart: React.FC<Props> = ({ period, onPeriodChange }) => {
  const { data, isLoading, error, refetch } = useGetFomoSmsVolumeQuery({ period });

  const rows = useMemo<StackedBarChartRow[] | undefined>(
    () => data?.data.map((r) => ({ date: r.date, value: r.count })),
    [data]
  );

  return (
    <StackedBarChart
      title="FOMO SMS Messages Sent"
      subtitle="Cap-hit upgrade prompts sent each day (UTC)"
      period={period}
      onPeriodChange={onPeriodChange}
      data={rows}
      isLoading={isLoading}
      error={!!error}
      onRetry={refetch}
      mode="single"
      singleColor={FOMO_COLOR}
      yAxisLabel="FOMO Messages Sent"
      valueNoun="FOMO messages sent"
      emptyMessage="No FOMO messages sent in this period"
    />
  );
};

export default FomoSmsChart;
